import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";

/**
 * Transient fields for ME are serializable fields, hence their values are saved.
 * This method resets them here - before clone action, validate action for submit for approval and in IMEEventServiceImpl on before Indicator save
 *
 * @see IMEEventServiceImpl
 * onBeforeIndicatorSave()
 */
@Injectable()
export class IndicatorWorkflowInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (this.isIndicatorWorkflowRequest(req) && req && req.body) {
      const body = JSON.parse(req.body);

      body.entity.isCloneAction = false;
      body.entity.isFullCloneAction = false;
      body.entity.isCreateAction = false;
      body.entity.isUpdateAction = false;

      req = req.clone({
        body
      });
    }

    return next.handle(req)
      .catch((error) => {
        return Observable.throw(error);
      }) as any;
  }

  private isIndicatorWorkflowRequest(req: HttpRequest<any>) {
    const isPut: boolean = req.method.toLowerCase() === "put";
    const regex = /.*prime\/workflow\/Indicator\//;
    return isPut && regex.test(req.url);
  }
}
